import { macAddress } from "@vuelidate/validators";
import axios from "axios";
let BASE_URL = process.env.NODE_ENV === "production" ? process.env.VUE_APP_API_URL : "";
export default {
  state: {
    serialPort: "",
    macAddress: "",
    bluetoothName: "",
    brainName: "",
    epochTimeStamp: "",
    amsPlayCategories: [],
    amsPlayCategoryData: [],
    inventoryOrderId: false,
    doRead: false,
    oidCodeTransferred: false,
    oidPenConnected: false,
    oidPenMac: "",
    oidCardScans: [],
    oidPenBattery : "",
    // oidCardDetails: { 123: "START_OID", 124: "END_OID", 125: "PLAY_OID", 126: "STOP_OID", 21: "DM1_CW_OID", 22: "DM1_ST_OID", 23: "DM1_ACW_OID"},
    oidCardDetails : { 1:"FWD_1_OID", 2:"FWD_2_OID", 3:"FWD_3_OID", 4:"FWD_4_OID", 5:"FWD_5_OID", 6:"BWD_1_OID", 7:"BWD_2_OID", 8:"BWD_3_OID", 9:"BWD_4_OID", 10:"BWD_5_OID", 11:"LEFT_1_OID", 12:"LEFT_2_OID", 13:"LEFT_3_OID", 14:"LEFT_4_OID", 15:"LEFT_5_OID", 16:"RIGHT_1_OID", 17:"RIGHT_2_OID", 18:"RIGHT_3_OID", 19:"RIGHT_4_OID", 20:"RIGHT_5_OID", 21:"DM1_CW_OID", 22:"DM1_ST_OID", 23:"DM1_ACW_OID", 24:"DM2_CW_OID", 25:"DM2_ST_OID", 26:"DM2_ACW_OID", 27:"AM1_CW_OID", 28:"AM1_ST_OID", 29:"AM1_ACW_OID", 30:"TIM_BLINK_OID", 31:"TIM_QUICK_OID", 32:"TIM_1_SEC_OID", 33:"TIM_2_SEC_OID", 34:"TIM_5_SEC_OID", 35:"DM1_LEDS_OFF_OID", 36:"DM1_LED_BLUE_OID", 37:"DM1_LED_GREEN_OID", 38:"DM1_LED_YELLOW_OID", 39:"DM1_LED_ORANGE_OID", 40:"DM1_LED_RED_OID", 41:"DM1_LED_VIOLET_OID", 42:"DM2_LEDS_OFF_OID", 43:"DM2_LED_BLUE_OID", 44:"DM2_LED_GREEN_OID", 45:"DM2_LED_YELLOW_OID", 46:"DM2_LED_ORANGE_OID", 47:"DM2_LED_RED_OID", 48:"DM2_LED_VIOLET_OID", 49:"AM1_LEDS_OFF_OID", 50:"AM1_LED_BLUE_OID", 51:"AM1_LED_GREEN_OID", 52:"AM1_LED_YELLOW_OID", 53:"AM1_LED_ORANGE_OID", 54:"AM1_LED_RED_OID", 55:"AM1_LED_VIOLET_OID", 56:"IR1_LEDS_OFF_OID", 57:"IR1_LED_BLUE_OID", 58:"IR1_LED_GREEN_OID", 59:"IR1_LED_YELLOW_OID", 60:"IR1_LED_ORANGE_OID", 61:"IR1_LED_RED_OID", 62:"IR1_LED_VIOLET_OID", 63:"LDR1_LEDS_OFF_OID", 64:"LDR1_LED_BLUE_OID", 65:"LDR1_LED_GREEN_OID", 66:"LDR1_LED_YELLOW_OID", 67:"LDR1_LED_ORANGE_OID", 68:"LDR1_LED_RED_OID", 69:"LDR1_LED_VIOLET_OID", 70:"TS1_LEDS_OFF_OID", 71:"TS1_LED_BLUE_OID", 72:"TS1_LED_GREEN_OID", 73:"TS1_LED_YELLOW_OID", 74:"TS1_LED_ORANGE_OID", 75:"TS1_LED_RED_OID", 76:"TS1_LED_VIOLET_OID", 77:"CS1_LEDS_OFF_OID", 78:"CS1_LED_BLUE_OID", 79:"CS1_LED_GREEN_OID", 80:"CS1_LED_YELLOW_OID", 81:"CS1_LED_ORANGE_OID", 82:"CS1_LED_RED_OID", 83:"CS1_LED_VIOLET_OID", 84:"FM1_HI_OID", 85:"FM1_HAPPY_OID", 86:"FM1_SAD_OID", 87:"FM1_WINK_OID", 88:"FM1_ANGRY_OID", 89:"FM1_CLEAR_OID", 90:"FM1_HI_OID_INV", 91:"FM1_HAPPY_OID_INV", 92:"FM1_SAD_OID_INV", 93:"FM1_WINK_OID_INV", 94:"FM1_ANGRY_OID_INV", 95:"FM1_CLEAR_OID_INV", 96:"LDR1_IF_OID", 97:"LDR1_END_OID", 98:"LDR1_ELSE_OID", 99:"TS1_IF_OID", 100:"TS1_END_OID", 101:"TS1_ELSE_OID", 102:"IR1_IF_OID", 103:"IR1_END_OID", 104:"IR1_ELSE_OID", 105:"CS1_IF_OID", 106:"CS1_END_OID", 107:"CS1_ELSE_IF_OID", 108:"CS1_ELSE_OID", 109:"CS_BLACK_OID", 110:"CS_RED_OID", 111:"CS_YELLOW_OID", 112:"CS_GREEN_OID", 113:"CS_BLUE_OID", 114:"CS_WHITE_OID", 115:"LOOP_FOREVER_START_OID", 116:"LOOP_FOREVER_END_OID", 117:"LOOP_REPEAT_1_OID",
    118:"LOOP_REPEAT_2_OID", 119:"LOOP_REPEAT_3_OID", 120:"LOOP_REPEAT_4_OID", 121:"LOOP_REPEAT_5_OID", 122:"LOOP_REPEAT_END_OID", 123:"START_OID", 124:"END_OID", 125:"PLAY_OID", 126:"STOP_OID" }
  },
  getters: {
    getMacAddress: (state) => state.macAddress,
    getEpochTimeStamp: (state) => state.epochTimeStamp,
    getbluetoothName: (state) => state.bluetoothName,
    getBrainName: (state) => state.brainName,
    getAmsPlayCategories: (state) => state.amsPlayCategories,
    getAmsPlayCategoryData: (state) => state.amsPlayCategoryData,
    getInventoryOrderId: (state) => state.inventoryOrderId,
    getOidCodeTransferred: (state) => state.oidCodeTransferred,
    getOidPenConnected: (state) => state.oidPenConnected,
    getOidPenMac: (state) => state.oidPenMac,
    getOidCardScans: (state) => state.oidCardScans,
    getOidPenBattery: (state) => state.oidPenBattery
  },
  actions: {
    fetchUserPrograms({ }){
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/programs/getUser`).then((response) => {
          resolve(response.data.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    fetchChapterPrograms({ },chapter_code){
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/programs/curriculum/program/${chapter_code}`).then((response) => {
          resolve(response.data.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    saveCurriculumprogram({ }, programPayload){
      return new Promise((resolve,reject) => {
        axios.post(`${BASE_URL}/programs/curriculum/program`,programPayload).then((response) => {
          resolve("success")
        }).catch(error => {
          reject(error)
        })
      })
    },
    fetchGetMacprogram({ state}) {
        return new Promise((resolve,reject) => {
          const brainName = state.brainName
          axios.get(`${BASE_URL}/programs/getMac/${brainName}`).then((response) => {
            resolve(response.data.data)
          });
        })
    },
    fetchSetEpochprogram({state}, epochTimeStamp='') {
      return new Promise((resolve,reject) => {
        try{
          const brainName = state.brainName
          axios.get(`${BASE_URL}/programs/setEpoch/${brainName}/${epochTimeStamp}`).then((response) => {
            resolve(response.data)
          });
        }catch(error){
          console.log(error)
          reject(error)
        }
      })
    },
    fetchWelcomeprogram({state}) {
      return new Promise((resolve,reject) => {
        try{
          const brainName = state.brainName
          axios.get(`${BASE_URL}/programs/setWelcomeCode/${brainName}`).then((response) => {
            resolve(response.data)
          });
        }catch(error){
          console.log(error)
          reject(error)
        }
      })
    },
    fetchTestingProgram({state}) {
      return new Promise((resolve,reject) => {
        try{
          const brainName = state.brainName
          axios.get(`${BASE_URL}/programs/setTestingCode/${brainName}`).then((response) => {
            resolve(response.data)
          });
        }catch(error){
          console.log(error)
          reject(error)
        }
      })
    },
    fetchOidProgram({state}) {
      return new Promise((resolve,reject) => {
        try{
          const brainName = state.brainName
          axios.get(`${BASE_URL}/programs/setOidCode/${brainName}`).then((response) => {
            resolve(response.data)
          });
        }catch(error){
          console.log(error)
          reject(error)
        }
      })
    },
    fetchSensorTestingProgram({ state},sensorName) {
      return new Promise((resolve,reject) => {
        const brainName = state.brainName
        axios.get(`${BASE_URL}/programs/sensor/testing/${brainName}/${sensorName}`).then((response) => {
          resolve(response.data)
        });
      })
    },
    addBrainTestCase({state},testCases){
      return new Promise((resolve,reject) => {
        try{
          const brainName = state.brainName
          const macAddress = state.macAddress
          const inventoryOrderId = state.inventoryOrderId
          const testCasePayload = { brainName,macAddress,testCases,inventoryOrderId }
          axios.post(`${BASE_URL}/programs/brain/testing`,testCasePayload).then((response) => {
            resolve(response.data)
          }).catch(err => {
            reject(err)
          })
        }catch(error){
          console.log(error)
          reject(error)
        }
      })
    },
    checkBrainMac({state},payload){
      return new Promise((resolve,reject) => {
        try{
          const brainName = state.brainName
          const macAddress = state.macAddress
          const inventoryOrderId = state.inventoryOrderId
         
          axios.post(`${BASE_URL}/programs/check/brain/mac`,{brainName,macAddress,inventoryOrderId,type: payload.type}).then((response) => {
            resolve(response.data)
          }).catch(err => {
            reject(err.response.data)
          })
        }catch(error){
          console.log(error)
          reject(error)
        }
      })
    },
    // Used by the BLE production test flow (ble_testing.vue) to confirm an
    // epoch read off the device over BLE is available before continuing.
    // Success (2xx): { status: 'success', url: <qr data uri>, data: { mac_address, epoch_key, is_available, ... } }
    // Failure (e.g. 400): { message: 'Epoch Not Found', ... } — treated as "not available", not a network error.
    checkBleEpoch({}, payload){
      return new Promise((resolve,reject) => {
        try{
          axios.post(`${BASE_URL}/programs/check/ble/epoch`,payload).then((response) => {
            resolve(response.data)
          }).catch(err => {
            reject(err.response ? err.response.data : err)
          })
        }catch(error){
          console.log(error)
          reject(error)
        }
      })
    },
    createEpochKey({state}){
      return new Promise((resolve,reject) => {
        try{
          const brainName = state.brainName
          const macAddress = state.macAddress
          const epochTimeStamp = state.epochTimeStamp
          const inventoryOrderId = state.inventoryOrderId
          const epochPayload = { brainName,macAddress,epochTimeStamp,inventoryOrderId }
         
          axios.post(`${BASE_URL}/programs/brain/epoch`,epochPayload).then((response) => {
            resolve(response.data.url)
          }).catch(err => {
            reject(err.response.data)
          })
        }catch(error){
          console.log(error)
          reject(error)
        }
      })
    },
    createBleEpochKey({state}){
      return new Promise((resolve,reject) => {
        try{
          const macAddress = state.macAddress
          const inventoryOrderId = state.inventoryOrderId
          const epochPayload = { macAddress,inventoryOrderId }
         
          axios.post(`${BASE_URL}/programs/pen/brain/epoch`,epochPayload).then((response) => {
            resolve(response.data.data)
          }).catch(err => {
            reject(err.response.data)
          })
        }catch(error){
          console.log(error)
          reject(error)
        }
      })
    },
    createPenEpochKey({state}){
      return new Promise((resolve,reject) => {
        try{
          const macAddress = state.oidPenMac
          const inventoryOrderId = state.inventoryOrderId
          const epochPayload = { macAddress,inventoryOrderId }
         
          axios.post(`${BASE_URL}/programs/pen/brain/epoch`,epochPayload).then((response) => {
            resolve(response.data.data)
          }).catch(err => {
            reject(err.response.data)
          })
        }catch(error){
          console.log(error)
          reject(error)
        }
      })
    },
    createPenCardEpochKey({state},product_code){
      return new Promise((resolve,reject) => {
        try{
          const inventoryOrderId = state.inventoryOrderId
          const epochPayload = { product_code,inventoryOrderId }
         
          axios.post(`${BASE_URL}/programs/pen/card/epoch`,epochPayload).then((response) => {
            resolve(response.data.data)
          }).catch(err => {
            reject(err.response.data)
          })
        }catch(error){
          console.log(error)
          reject(error)
        }
      })
    },
    // async sleep(ms) {
    //   console.log("sleep12")
    //     return await new Promise((resolve) => setTimeout(resolve, ms));
    // },
    writeData({state}, data) {
      return new Promise(async (resolve,reject) => {
        try{
          const serialPort = state.serialPort
          const encoder = new TextEncoder();
          const writer = serialPort.writable.getWriter()
          let toWrite = encoder.encode(data);
          await writer.write(toWrite);
          writer.releaseLock();
          console.log("write success")
          resolve("success")
        }catch(error){
          reject(error)
        }
      })
    },
    resetBrain({ dispatch,state }) {
      return new Promise(async (resolve,reject) => {
        try{
          const serialPort = state.serialPort
          //await dispatch("sleep",500);
          await new Promise((resolve) => setTimeout(resolve, 500));
          await serialPort.setSignals({ dataTerminalReady: false });
          await serialPort.setSignals({ requestToSend: false });
         // await dispatch("sleep",1000);
          await new Promise((resolve) => setTimeout(resolve, 1000));
          await serialPort.setSignals({ dataTerminalReady: true });
          await serialPort.setSignals({ requestToSend: false });
          await serialPort.setSignals({ dataTerminalReady: true });
          //await dispatch("sleep",100);
          await new Promise((resolve) => setTimeout(resolve, 100));
          await serialPort.setSignals({ dataTerminalReady: false });
          await serialPort.setSignals({ requestToSend: true });
          await serialPort.setSignals({ dataTerminalReady: false });
         // await dispatch("sleep",50);
          await new Promise((resolve) => setTimeout(resolve, 50));
          await serialPort.setSignals({ dataTerminalReady: false });
          await serialPort.setSignals({ requestToSend: false });
          await serialPort.setSignals({ dataTerminalReady: false });
          console.log("RESET BRAIN COMPLETE");
          resolve("RESET BRAIN COMPLETE")
        }catch(error){
          reject(error)
        }
      })
    },
    readMAC({ commit,state }) {
      return new Promise(async (resolve,reject) => {
          class LineBreakTransformer {
              constructor() {
                  this.container = '';
              }
          
              transform(chunk, controller) {
                  if(!chunk.includes('raw REPL') && !chunk.includes('<')) {
                      this.container += chunk;
                      const lines = this.container.split('\r\n');
                      this.container = lines.pop();
                      lines.forEach(line => controller.enqueue(line));
                  }
              }
          
              flush(controller) {
                  controller.enqueue(this.container);
              }
          }
          const serialPort = state.serialPort
          while (serialPort.readable) {
              const reader = serialPort.readable
              .pipeThrough(new TextDecoderStream())
              .pipeThrough(new TransformStream(new LineBreakTransformer()))
              .getReader();
              try {
                  while (true) {
                      const { value, done } = await reader.read();
                      console.log(value)
                      if (done) {
                          break;
                      }
                      if (value.length === 17) {
                        const macAddress = value.replaceAll(":","")
                        let bluetoothName = ""
                        if(state.brainName == "FULL 2.0 BLE"){
                          bluetoothName = `FB_${macAddress.slice(-6)}`
                        }else if(state.brainName  == "LITE 2.0 BLE"){
                          bluetoothName = `LB_${macAddress.slice(-6)}`
                        }else if(state.brainName  == "MEXcore"){
                          bluetoothName = `MEX_${macAddress.slice(-6)}`
                        }else if(state.brainName  == "MEXcore+"){
                          bluetoothName = `MEX_${macAddress.slice(-6)}`
                        }else if(state.brainName  == "Maker Board 2.0"){
                          bluetoothName = `MB_${macAddress.slice(-6)}`
                        }else if(state.brainName = "TWEAK 2.0"){
                          bluetoothName = `TK_${macAddress.slice(-6)}`
                        }
                        commit("setMacAddress",macAddress)
                        commit("setBluetoothName",bluetoothName)
                        break;
                      }
                  }
              } catch (error) {
                  console.error('READ DATA ERROR: ', error);
                  reject(error)
              } finally {
                  await reader.releaseLock();
                  break;
              }
          }
          resolve("Success")
      })
    },
    transferCode({ dispatch,state }, transferPayload) {
      return new Promise(async (resolve,reject) => {
        try{
          let userCode = transferPayload.program;
          const brainName = state.brainName
          console.log(userCode)
          userCode = userCode.split('\n').join('\\n');
          userCode = userCode.split(`'`).join(`"`);
          const script1 = `f = open('${transferPayload.fileName}', 'wb')\r\n`;
          const script2 = `f.write(b'`;
          const script3 = `')\r\n`;
          const script4 = `f.close()\r\n`;
          await dispatch("writeData",`\x03`)
          await new Promise((resolve) => setTimeout(resolve, 500));
          await dispatch("writeData",`\x01`)
          await new Promise((resolve) => setTimeout(resolve, 500));
          await dispatch("writeData",script1)
          await new Promise((resolve) => setTimeout(resolve, 500));
          await dispatch("writeData",script2)
          await new Promise((resolve) => setTimeout(resolve, 500));
          if (brainName === 'FULL 2.0 BLE') { 
              const CHUNK_SIZE = 200;
              for (let i = 0; i < userCode.length; i += CHUNK_SIZE) {
                  const chunk = userCode.slice(i, i + CHUNK_SIZE);
                  await dispatch("writeData",chunk)
                  await new Promise((resolve) => setTimeout(resolve, 100));
              }
          } else {
              await dispatch("writeData",userCode)
              await new Promise((resolve) => setTimeout(resolve, 500));
          }
          await dispatch("writeData",script3)
          await new Promise((resolve) => setTimeout(resolve, 500));
          await dispatch("writeData",script4)
          await new Promise((resolve) => setTimeout(resolve, 500));
          await dispatch("writeData",`\x04`)
          await new Promise((resolve) => setTimeout(resolve, 500));
          await dispatch("writeData",`\x02`)
          await new Promise((resolve) => setTimeout(resolve, 500));
          console.log("TRANSFER CODE COMPLETE");  
          resolve("TRANSFER CODE COMPLETE")
        }catch(error){
          reject(error)
        }
      })
    },
    async getBoardInfo({ dispatch,commit,state }) {
      const script = 'import uos\r\nprint()\r\nprint(uos.uname())\r\n';
      await dispatch("writeData",`\x03`)
      await new Promise((resolve) => setTimeout(resolve, 500));
      await dispatch("writeData",`\x01`)
      await new Promise((resolve) => setTimeout(resolve, 500));
      await dispatch("writeData",script)
      await new Promise((resolve) => setTimeout(resolve, 500));
      await dispatch("writeData",`\x04`)
      await new Promise((resolve) => setTimeout(resolve, 500));
      await dispatch("writeData",`\x02`)
      await new Promise((resolve) => setTimeout(resolve, 500));

      // class LineBreakTransformer {
      //   constructor() {
      //       this.container = '';
      //   }
    
      //   transform(chunk, controller) {
      //       //if(!chunk.includes('raw REPL') && !chunk.includes('<')) {
      //           this.container += chunk;
      //           const lines = this.container.split('\r\n');
      //           this.container = lines.pop();
      //           lines.forEach(line => controller.enqueue(line));
      //      // }
      //   }
    
      //   flush(controller) {
      //       controller.enqueue(this.container);
      //   }
      // }

      // const serialPort = state.serialPort
      // while (serialPort.readable) {
      //     const reader = serialPort.readable
      //     .pipeThrough(new TextDecoderStream())
      //     .pipeThrough(new TransformStream(new LineBreakTransformer()))
      //     .getReader();
      //     try {
      //         while (true) {
      //             const { value, done } = await reader.read();
      //             if (done) {
      //                 break;
      //             }
      //             if(value.includes('sysname')) {
      //                 let arr = value.split("(")[1].split(")")[0].split(",")
      //                 arr = arr.map((a) => {
      //                   let b = a.trim().split("=")
      //                   let c = `{ "${b[0]}":"${b[1].replace(/\'/g, "")}" }`
      //                   return JSON.parse(c)
      //                 })
      //                 let boardInfo = {}
      //                 arr.map((i)=> boardInfo[Object.keys(i)[0]] = i[Object.keys(i)[0]])
      //                 let boardName = boardInfo.machine;
      //                 if (boardName === 'FULL 2.0') {
      //                   boardName = 'FULL 2.0 BLE'
      //                 } else if (boardName === 'LITE 2.0') {
      //                   boardName ='LITE 2.0 BLE'
      //                 } else if (boardName === 'MKB 2.0') {
      //                   boardName = 'Maker Board 2.0'
      //                 }
      //                 commit("setBrainname",boardName)
      //                 console.log(boardInfo);
      //                 break;
      //             }
      //         }
      //     } catch (error) {
      //         console.error('GET BOARDINFO ERROR: ', error);
      //     } finally {
      //         await reader.cancel();
      //         break;
      //     }
      // }
    },
    fetchAmsPlayCategory({commit}, type){
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/programs/ams/play/category/${type}`).then((response) => {
          commit("setAmsPlayCategory",response.data.data)
          resolve(response.data.data)
        }).catch(error => {
          reject(error.response.data)
        })
      })
    },
    fetchAmsPlayCategoryDetails({commit}, category_id){
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/programs/ams/play/details/${category_id}`).then((response) => {
          commit("setAmsPlayCategoryData",response.data.data)
          resolve(response.data.data)
        }).catch(error => {
          reject(error.response.data)
        })
      })
    },
    addAmsPlayCategory({dispatch}, amsPlayPayload){
      return new Promise((resolve,reject) => {
        axios.post(`${BASE_URL}/programs/ams/play/category`,amsPlayPayload).then((response) => {
          dispatch("fetchAmsPlayCategory",amsPlayPayload.type)
          resolve(response.data.data)
        }).catch(error => {
          reject(error.response.data)
        })
      })
    },
    uploadCategoryImage({}, imagePayload){
      return new Promise((resolve,reject) => {
        axios.post(`${BASE_URL}/programs/upload/ams/play/category/image`,imagePayload).then(async (response) => {
          await axios.put(response.data.url, imagePayload.file, { headers: {'Content-Type': imagePayload.file.type} })
          console.log(response.data.url)
          resolve(response.data.url.split("?Content-Type=")[0])
        }).catch(error => {
          console.log(error)
          reject(error)
        })
      })
    },
    addAmsPlayCategoryDetail({}, categoryPayload){
      return new Promise((resolve,reject) => {
        axios.post(`${BASE_URL}/programs/ams/play/category/detail`,categoryPayload).then((response) => {
          resolve(response.data.data)
        }).catch(error => {
          reject(error.response.data)
        })
      })
    },
    removeAmsPlayCategoryDetail({}, categoryPayload){
      return new Promise((resolve,reject) => {
        axios.put(`${BASE_URL}/programs/delete/ams/play/category/data`,categoryPayload).then((response) => {
          resolve(response.data.data)
        }).catch(error => {
          reject(error.response.data)
        })
      })
    },
    createChapterProgram({}, programPayload){
      return new Promise((resolve,reject) => {
        axios.post(`${BASE_URL}/programs/chapter/program`,programPayload).then((response) => {
          resolve(response.data.data)
        }).catch(error => {
          reject(error.response.data)
        })
      })
    },
    async serialRead({ dispatch,commit,state }) {
      //return new Promise(async (resolve,reject) => {
        class LineBreakTransformer {
          constructor() {
              this.container = '';
          }
      
          transform(chunk, controller) {
              //if(!chunk.includes('raw REPL') && !chunk.includes('<')) {
                  this.container += chunk;
                  const lines = this.container.split('\r\n');
                  this.container = lines.pop();
                  lines.forEach(line => controller.enqueue(line));
            // }
          }
      
          flush(controller) {
              controller.enqueue(this.container);
          }
        }

        const serialPort = state.serialPort
        const doRead = state.doRead
        while (serialPort.readable) {
          const serialReader = serialPort.readable
              .pipeThrough(new TextDecoderStream())
              .pipeThrough(new TransformStream(new LineBreakTransformer()))
              .getReader();
          try {
              while (doRead) {
                const { value, done } = await serialReader.read();
                  if (done) {
                      console.log('DONE');
                      break;
                  }
                  console.log(value);
                  if (value.includes('Error')) {
                      throw new Error('error occured');
                  } else if (value.includes('sysname')) {
                    let arr = value.split("(")[1].split(")")[0].split(",")
                    arr = arr.map((a) => {
                      let b = a.trim().split("=")
                      let c = `{ "${b[0]}":"${b[1].replace(/\'/g, "")}" }`
                      return JSON.parse(c)
                    })
                    let boardInfo = {}
                    arr.map((i)=> boardInfo[Object.keys(i)[0]] = i[Object.keys(i)[0]])
                    let boardName = boardInfo.machine;
                    if (boardName === 'FULL 2.0') {
                        boardName= 'FULL 2.0 BLE';
                    } else if (boardName === 'LITE 2.0') {
                        boardName= 'LITE 2.0 BLE';
                    } else if (boardName === 'MKB 2.0') {
                        boardName= 'Maker Board 2.0';
                    } else if (boardName === 'MKB 3.0') {
                        boardName= 'Maker Board 3.0';
                    }
                    if (boardInfo.version.startsWith('v1.16')) {
                        boardInfo.version = '1.0';
                    }
                    commit("setBrainname",boardName)
                    console.log(boardInfo);
                  } else if (value.includes('MAC')) {
                    const macAddress = value.split(':')[1].trim();
                    let bluetoothName = ""
                    if(state.brainName == "FULL 2.0 BLE"){
                      bluetoothName = `FB_${macAddress.slice(-6)}`
                    }else if(state.brainName  == "LITE 2.0 BLE"){
                      bluetoothName = `LB_${macAddress.slice(-6)}`
                    }else if(state.brainName  == "MEXcore"){
                      bluetoothName = `MEX_${macAddress.slice(-6)}`
                    }else if(state.brainName  == "MEXcore+"){
                      bluetoothName = `MEX_${macAddress.slice(-6)}`
                    }else if(state.brainName  == "Maker Board 2.0"){
                      bluetoothName = `MB_${macAddress.slice(-6)}`
                    }else if(state.brainName == "TWEAK 2.0"){
                      bluetoothName = `TK_${macAddress.slice(-6)}`
                    }else if(state.brainName == "Maker Board 3.0"){
                      bluetoothName = `MKB3_${macAddress.slice(-6)}`
                    }else if(state.brainName == "MEXcore+ 2.0"){
                      bluetoothName = `MEXP2_${macAddress.slice(-6)}`
                    }
                    commit("setMacAddress",macAddress)
                    commit("setBluetoothName",bluetoothName)
                  } else if (value.includes('EPOCH')) {
                    const writtenEpoch = value.split(':')[1].trim();
                    console.log('WRITTEN EPOCH: ', writtenEpoch);
                    commit("setEpochTime",writtenEpoch)
                  } else if (value.includes('WRITTEN SIZE')) {
                      const writtenSize = value.split(':')[1].trim();
                      console.log('WRITTEN FILE SIZE: ', Number(writtenSize));
                  } else if(value.includes('Loop Status')){
                    const loop_status = value.split('=')[1].trim();
                    if(loop_status == "START")  commit("setOidCodeTransferred",true)
                    else commit("setOidCodeTransferred",false)
                  } else if(value.includes('Connection Status')){
                    const connection_status = value.split('=')[1].trim();
                    if(connection_status == "CONNECTED") commit("setOidPenConnected",true)
                    else{
                      state.oidCardScans = []
                      commit("setOidPenConnected",false)
                    } 
                  } else if(value.includes('Central MADD')){
                    const macAddress = value.split('=')[1].trim();
                    if (macAddress)  commit("setOidPenMac",macAddress)
                  } else if(value.includes('ID')){
                    const oidCardDetails = state.oidCardDetails
                    const card_id = value.split('=')[1].trim();
                    commit("setCardId",oidCardDetails[card_id])
                  } else if(value.includes("Battery Level ADC")){
                    const battery_level = value.split('=')[1].trim();
                    if(battery_level < 3400) commit("setOidPenBattery","Low Battery")
                    else commit("setOidPenBattery","Full Battery")
                  }
              }
          } catch (error) {
              console.error('READ DATA ERROR: ', error);
             // reject(error)
          } finally {
              break;
          }
        }
        //resolve("Success")
      //})
    }
  },
  mutations: {
    setSerialPort: (state, serialPort) => (state.serialPort = serialPort),
    setEpochTime: (state, epochTimeStamp) => (state.epochTimeStamp = epochTimeStamp),
    setMacAddress: (state, macAddress) => (state.macAddress = macAddress),
    setDoRead: (state, doRead) => (state.doRead = doRead),
    setBluetoothName: (state, bluetoothName) => (state.bluetoothName = bluetoothName),
    setBrainname: (state, brainName) => (state.brainName = brainName),
    setAmsPlayCategory: (state, amsPlayCategories) => (state.amsPlayCategories = amsPlayCategories),
    setAmsPlayCategoryData: (state, amsPlayCategoryData) => (state.amsPlayCategoryData = amsPlayCategoryData),
    setInventoryOrderId: (state, inventoryOrderId) => (state.inventoryOrderId = inventoryOrderId),
    setOidCodeTransferred: (state, oidCodeTransferred) => (state.oidCodeTransferred = oidCodeTransferred),
    setOidPenConnected: (state, oidPenConnected) => (state.oidPenConnected = oidPenConnected),
    setOidPenMac: (state, penMac) => (state.oidPenMac = penMac),
    setCardId: (state, cardId) => (state.oidCardScans.push(cardId)),
    setOidCardScans: (state, cardId) => (state.oidCardScans = cardId),
    setOidPenBattery: (state, oidPenBattery) => (state.oidPenBattery = oidPenBattery),
  },
};
